import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'articles',
    label: 'Articles',
    type: types.FUTURESIGHT_CONNECT,
    children: [
      {
        key: 'heroImageUrl',
        label: 'Hero Image',
        type: types.TEXT
      },
      {
        key: 'published_at',
        label: 'Published At',
        type: types.DATE
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA
      },
      {
        key: 'tags',
        label: 'Tags',
        type: types.ARRAY,
        children: {
          key: 'tag',
          label: 'Tag',
          type: types.TEXT
        }
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  articles: []
};

export default {
  title: 'Related Articles',
  id: 'RelatedArticles',
  propsSchema,
  defaultProps
};
